import { Field, Formik } from "formik";
import moment from "moment";
import { useState } from "react";
import Fields from "../formFields";
import UTILS from "../../utils";
import PropTypes from "prop-types";
import { useMutation, useQueryClient } from "react-query";
import { updateVirtualClass } from "../../api/virtualClass";

export default function BlockRescheduleClass(props) {
  const { handleCloseModal, classDetails } = props;
  const queryClient = useQueryClient();
  const fetchData = async () => {
    await queryClient.refetchQueries(["getAllVirtualClassesRTQ"]);
  };
  const {
    isLoading: isUpdateLoading,
    mutate: updateMutate,
    data: updateData,
  } = useMutation(updateVirtualClass, {
    onSuccess: (data, variables) => {
      fetchData();
      handleCloseModal();
      //   getClassDetailsById(data.id);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const handleModalSubmit = (values, { setSubmitting }) => {
    const {
      id,
      teacher_id,
      title,
      description,
      repeats,
      duration_seconds,
      subject,
      date,
    } = values;

    const start_time = moment(values.date).unix();
    const end_time = start_time + duration_seconds.value;
    const payload = {
      teacher_id: teacher_id,
      start_time: start_time, // has to be an int
      end_time: end_time,
      title,
      description,
      duration_seconds: duration_seconds.value,
      repeats: values?.repeats,
      subject: {
        id: subject.subject.id,
        title: subject.subject.title,
        description: subject.subject.description,
      },
    };
    payload.id = id;
    console.log("payload", payload);
    updateMutate(payload);
  };

  return (
    <>
      <div className="mt-2">
        <div className="mt-2">
          <Formik initialValues={classDetails} onSubmit={handleModalSubmit}>
            {({ values, handleSubmit, isSubmitting }) => (
              <form onSubmit={handleSubmit} className="pt-2 md:pt-6">
                <div className="flex gap-2">
                  <div className={"flex-1"}>
                    <Field
                      type={"text"}
                      name={`title`}
                      wrapperClasses={"mb-0"}
                      placeholder="Title"
                      component={Fields.FieldInput}
                      disabled
                    />
                  </div>
                  <div className={"flex-1"}>
                    <Field
                      type={"text"}
                      name={`subject.title`}
                      wrapperClasses={"mb-0"}
                      placeholder="Subject"
                      component={Fields.FieldInput}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex gap-2 h-60">
                  <div className="flex-1">
                    <Field
                      name="date"
                      wrapperClasses={"col-span-4"}
                      minDate={new Date()}
                      iconBefore={
                        <i className={`text-xl icon icon-calendar`}></i>
                      }
                      component={Fields.FieldDateTime}
                      timeConstraints={{ minutes: { step: 5 } }}
                    />
                  </div>

                  <div className="flex-1">
                    <Field
                      type="select"
                      name="duration_seconds"
                      placeholder="Add Duration"
                      iconBefore={<i className={`text-xl icon icon-clock`}></i>}
                      options={UTILS.virtualClass.durationOptions()}
                      wrapperClasses={"flex-1"}
                      component={Fields.FieldSelect}
                    />
                  </div>
                </div>
                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    className="inline-flex justify-center px-8 py-2 text-sm font-medium text-zinc-900 bg-transparent border-2 border border-zinc-200 rounded-md hover:bg-zinc-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-zinc-500"
                    onClick={handleCloseModal}
                    disabled={isUpdateLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="ml-2 inline-flex justify-center px-8 py-2 text-sm font-medium text-white bg-black border border-transparent rounded-md hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-zinc-500"
                    disabled={isUpdateLoading}
                  >
                    Save
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

BlockRescheduleClass.propTypes = {
  handleCloseModal: PropTypes.func,
  classDetails: PropTypes.object,
};

BlockRescheduleClass.defaultProps = {
  handleCloseModal: () => {},
  classDetails: {},
};
